// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".component-radiogroup .component-radiogroup-checkbox[data-v-2982dcd4] {\n  margin-top: 10px;\n}\n.component-radiogroup .component-radiogroup-checkbox[data-v-2982dcd4]:first-child {\n  margin-top: 0;\n}\n", ""]);
// Exports
module.exports = exports;
